import { render, staticRenderFns } from "./StructuredJsonForm.vue?vue&type=template&id=602bcd93&scoped=true"
import script from "./StructuredJsonForm.vue?vue&type=script&lang=js"
export * from "./StructuredJsonForm.vue?vue&type=script&lang=js"
import style0 from "./StructuredJsonForm.vue?vue&type=style&index=0&id=602bcd93&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "602bcd93",
  null
  
)

export default component.exports